import { pgEnum } from "drizzle-orm/pg-core";

export const admin_user_role = pgEnum("admin_user_role", [
  "admin",
  "company_admin",
  "user",
]);
